import React from 'react';

import { FormattedMessageWrappedInSpan } from '../misc';

export default function PhotoBookMsg(props) {
  return <FormattedMessageWrappedInSpan id="messages.photoBook" defaultMessage="myRacebook" />;
}
